exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-6a8c4838] { margin-bottom: 15px;\n}\n.qr-wrapper[data-v-6a8c4838] { text-align: center;\n}\n.qr-img[data-v-6a8c4838] { width: 260px; height: 260px;\n}\n.qr-info p[data-v-6a8c4838] { margin: 6px 0;\n}\n.qr-tip[data-v-6a8c4838] { color: #999; font-size: 12px;\n}\n.relate-tip[data-v-6a8c4838] { color: #999; font-size: 12px; margin-top: 12px;\n}\n", ""]);

// exports
